export default {
    userDeleted: 'User is deleted',
    profileBadgeRole: {
        banned: 'Banned Member',
        whitelisted: 'Partner',
        admin: 'Community Owner',
        moderator: 'Community Admin',
    },
    youDontHaveFollowings: "You don't follow anyone yet",
    userDontHaveFollowings: "This user doesn't follow anyone",
    youDontHaveFollowers: 'No followers at the moment',
    userHasNoFollowers: "This user doesn't have followers",
    post: 'Post',
    followButton: {
        follow: 'Follow',
        unfollow: 'Following',
        unfollowModal: {
            title: 'Unfollow member',
            text: 'Are you sure you want to unfollow this member?',
        },
    },
    ifYouDontHaveEnough: "if you don't have enough available balance deposit more from the deposit button on the cashable wallet",
    superComment: 'super comment',
    report: 'Report',
    other: 'Other',
    modActivities: {
        modalTitle: 'Select your reason to {{action}} this {{entity}}',
        actions: {
            banUser: 'Ban memeber',
            hidePost: 'Hide post',
            hideComment: 'Hide comment',
            hideSuperComment: 'Hide super comment',
            blockChatUser: 'Block member from chat',
            blockUser: 'Block user',
        },
        banUser: {
            spam: 'Posting spam or unrelated content',
            fraud: 'Coordinated post buying or other fraudulent activity',
            hateful: 'Being hateful or threatening community member',
        },
        hidePost: {
            spam: 'This post is spam or unrelated content',
            hateful: 'This post is hateful or threatening',
            nudity: 'This post displays nudity or other inappropriate materials',
        },
        hideComment: {
            spam: 'This comment is spam or unrelated content',
            hateful: 'This comment is hateful or threatening',
            nudity: 'This comment displays nudity or other inappropriate materials',
        },
        hideSuperComment: {
            spam: 'This super comment is spam or unrelated content',
            hateful: 'This super comment is hateful or threatening',
            nudity: 'This super comment displays nudity or other inappropriate materials',
        },
        blockChatUser: {
            spam: 'Posting spam or unrelated content',
            hateful: 'Being hateful or threatening community member',
            nudity: 'Posting nudity or other inappropriate materials',
        },
    },
    reportOptions: {
        user: {
            profileIncludes: 'Profile includes obscene, hateful, vulgar, or pornographic content',
            harrasment: 'Harassment or bullying',
            suspect: 'Suspected fake or fraudulent',
            spam: 'Spam',
        },
        community: {
            obscene: 'Community includes obscene, hateful, vulgar, or pornographic content',
            harrasment: 'Harassment or bullying',
            false: 'False information',
            spam: 'Spam',
        },
        content: {
            obscene: 'Post includes obscene, hateful, vulgar, or pornographic content',
            violates: 'Violates community guidelines',
            suspected: 'Suspected fraud',
            spam: 'Spam',
            commentIncludes: 'Comment includes obscene, hateful, vulgar, or pornographic content',
            harrasment: 'Harassment or bullying',
        },
    },
    postMenuPopover: {
        hideToken: 'Hide posts from this channel',
        share: {
            response: 'Share response',
            post: 'Share post',
            responseThread: 'Share thread from start',
        },
        totalViews: 'Views: {{ totalViews }}',
        manageDraftPostLabel: 'Manage draft',
        editFlair: 'Edit topics',
    },
    PinnedIndicator: {
        label: 'Pinned',
    },
    seeMore: 'See more',
    tooManyPinnedPostsErrorMessage: 'Too many pinned posts',
    activity: 'Activity',
    rateLimitError: "You're posting too frequently please take a short break before posting again.",
    authModalLoginSubtitle: 'Sign in to join the discussion and build Reputation',
    createPasswordHelpTip:
        'Choose a strong password with minimum length of 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character',
    chooseLoginUser: {
        title: 'Select account',
        subtitle:
            'Multiple accounts across network domains were found registered with the same Legacy account (Email, Twitter, Google). Please select the account you’d like to log in with, or merge the accounts.',
        submitButton: 'Sign in',
        mergeAccounts: 'Merge accounts',
        mainAccountLabel: 'Primary',
        userUnableToMergeMainAccount: 'Primary account can not be merged ',
        userUnableToMergeDueToTokenOwernship: 'User is a channel owner and can not be merged',
        userUnableToMergeDueToTokenOwernshipHelpTip: 'User is the channel owner of: {{ ownedTokens }}. You can transfer channel ownership under edit channel',
        aletBox: 'By selecting Merge accounts, you can choose an account to be used as your primary account across the network. Continue to Merge accounts to learn more',
    },
    mergeAccountWrapper: {
        title: 'Merge accounts',
        subtitle: 'Multiple accounts across network domains were found registered with the same Legacy account (Email, Twitter, Google).',
        alertBox: 'By selecting Merge accounts, current logged in account will be used as your primary account across the network. Continue to Merge accounts to learn more',
        cancelButton: 'Cancel',
        backButton: 'Back',
    },
    mergeAccount: {
        title: 'Merge accounts',
        subtitle: 'Please select the Primary account you’d like to use across the network:',
        subtitleIntialSelectedUser: 'The Primary account you’d like to use across the network is:',
        submitButton: 'Next',
        description:
            'All accounts registered with the same Legacy account will be merged into the selected Primary account with secondary account wallet balances transferring to the Primary account.\n\nMerged secondary accounts will no longer be accessible, but all transaction activity will be forwarded to the Primary account (revenues, tips, profits, etc).',
        cancel: 'Cancel',
        aletBox: 'Warning: Account merging is permanent and cannot be changed later by anyone.',
        failedForwardedAccounts: 'Unable to merge these accounts:',
        confirmation: {
            subtitle: 'After finalizing, this will be the Primary account used across the network:',
            back: 'Back',
            submitButton: 'Confirm',
        },
    },
    postResponseActionButtons: {
        menuPopover: {
            downloadVideo: 'Download video',
        },
    },
    postResponseVideoPlayer: {
        totalViews_one: '{{ count }} view',
        totalViews_other: '{{ count }} views',
        seeMore: 'See more',
        mobileWelcomeScreen: {
            title: 'Welcome to Video Threads!',
            message:
                'Swipe left for the top response, or righ* for the video being responded to. Swiping up/down will navigate through different videos or threads.\n Your next favorite discussion is just a swipe away!',
        },
    },
    outUpvotedNotificationStats: '{{ numUpvotes }} Promotions',
    createAccountDescription: 'Sign up to join the discussion and build Reputation',
    loginDescription: 'Sign in to join the discussion and build Reputation',
    viewType: 'Visits',
    createTokenImageFieldLabel: 'Logo',
    createTokenCoverImageFieldLabel: 'Cover Image',
    createTokenTitleFieldLabel: 'Channel Name',
    createTokenTitlePlaceholder: 'Name your Channel',
    createTokenAboutFieldLabel: 'About your Channel',
    createTokenAboutPlaceholder: 'Tell everyone what your channel is about',
    editTokenTitleFieldLabel: 'Channel Name',
    editTokenTitlePlaceholder: 'Name your Channel',
    editTokenNewOwnerFieldLabel: 'Transfer Ownership',
    editTokenNewOwnerPlaceholder: 'Type username',
    editTokenNamePlaceholder: 'Name your Channel',
    editTokenAboutFieldLabel: 'About your Channel',
    editTokenAboutPlaceholder: 'Tell everyone what your channel is about',
    tokenListEmptyStateTitle: 'There are no channels',
    tokenListEmptyStateSubtitle: 'Ready to join one?',
    tokenListEmptyStateActionButton: 'Discover Channels',
    deleteTokenLabel: 'Hide Channel',
    undeleteTokenLabel: 'Unhide Channel',
    buyButtonDisabledTokenStatus0: 'New channels need to be live for about 3 minutes before you can deposit',
    createNewPollTokenStatus0: 'New channels need to be live for about 3 minutes before you can create a poll',
    editTokenImageLabel: 'Logo',
    editTokenCoverImageLabel: 'Cover Image',
    'Edit token': 'Edit Channel',
    createTokenNamePlaceholder: 'Choose Token Symbol',
    usernameAndPasswordLogin: 'Login with Username',
    editPostComment: 'Edit',
    buy: 'Deposit',
    tokenMenuPopover: {
        aboutMenuItem: 'About',
        transferTokenOwnership: 'Transfer ownership',
        reportsMenuItem: 'Reports',
    },
    transferOwnership: {
        modalTitle: 'Transfer channel ownership',
        subtitle: 'Transferring forum ownership will give complete control of the forum to the selected account.',
        aletBox: 'Make sure to enter the correct account, as ownership is not reversible.',
        submitButton: 'Next',
        cancelButton: 'Cancel',
        newOwnerFieldLabel: 'New owner',
        confirmation: {
            pendingBlockchainConfirmation: 'Note: Transferring ownership can take up to 3 minutes to fully execute.',
            subtitle: 'After confirming, the new owner of {{ tokenName }} will be:',
            back: 'Back',
            submitButton: 'Confirm',
        },
        successMsg: 'Your request to transfer ownership was submitted and will be executed within 3 minutes.',
        successSubmit: 'Done',
    },
    goToPorifle: 'Go to Profile',
    goToPost: 'Go to Post',
    goToComment: 'Go to comment',
    backToPost: 'Back to post',
    backToPostsLink: 'Back to posts',
    backToTokenPage: 'Back to {{ tokenName }}',
    backToUserPage: 'Back to {{ username }}',
    backToSearchResults: 'Back to search results',
    backToFeed: 'Back to channel',
    blockUserDM: 'Block user',
    youBlockedUser: 'You blocked {{ userName }}',
    message: 'Message',
    unblockUserDM: 'Unblock user',
    tokenPagePostsTab: 'Posts',
    tokenPageReportsTab: 'Reports',
    tokenPageTransactionsTab: 'Activity',
    'reactionsCount.thumb-up': 'Top',
    createdAt: 'Newest',
    sortBy: 'Sort by',
    txLogTransactionTitle: 'Activity',
    majorUpgrades: 'Major Upgrades in Progress',
    tokenPageAboutTab: 'about',
    tokenPagePollsTab: 'polls',
    badNonceErrorMessage: 'Slow Down :) Each action is recorded in a public ledger to ensure immutability. Please leave about 2 minutes between each action so it can be recorded.',
    unableToUndelete: 'We are sorry, but someone else has deleted this comment. You cannot un-delete it for now.',
    generalErrorMessage: 'Seems like something went wrong, we are looking into it. Please try again in a few minutes.',
    generalErrorMessageErrorBoundry: 'Failed to load content, please try again later.',
    cantCommentPostHidden: 'This post is hidden. You can not comment',
    postListCollapsibleTriggerPublishedPosts: 'Published posts ({{ total }})',
    loadMoreComments: 'Load more',
    comments: 'Comments',
    reply: 'Reply',
    delete: 'Hide',
    unDelete: 'Unhide',
    token: 'token',
    commentInputPlaceholder: 'Write a comment (use @ to tag)',
    commentInputPlaceholderSending: 'Sending...',
    commentInputPlaceholderAnonymous: 'Write an anonymous comment...',
    commentInput: {
        linkMetaFetcher: {
            fetchingLinkMeta: 'Fetching link info...',
            errorFetchingLinkMeta: "Coludn't fetch link info",
        },
    },
    approveOrDeleteButtons: {
        approveButton: 'Approve',
        deleteButton: 'Delete',
    },
    postStatus0: 'Published',
    postStatus1: 'Hidden by admin',
    postStatus2: 'Hidden by publisher',
    postStatus3: 'Hidden by admin',
    postStatus4: 'Hidden by admin',
    postStatus5: 'Pending admin approval',
    postStatus6: 'Pending transcript',
    postStatus7: 'Published unlisted',
    postStatus8: 'Scheduled',
    postStatus9: 'Draft',
    postStatusIndicator: {
        status0: 'Published at {{ details }}',
        status1: 'Hidden by admin',
        status2: 'Hidden by publisher',
        status3: 'Hidden by admin',
        status4: 'Hidden by admin',
        status5: 'Pending admin approval',
        status6: 'Pending transcript',
        status7: 'Published unlisted',
        status8: 'Scheduled for {{ details }}',
        status9: 'Draft',
    },
    commentStatusIndicator: {
        status0: 'Published',
        status1: 'Hidden by admin',
        status2: 'Hidden by publisher',
        status3: 'Hidden by admin',
        status4: 'Hidden by admin',
        status5: 'Pending admin approval',
    },
    responseStatus0: 'Published',
    responseStatus1: 'The media is no longer available',
    responseStatus2: 'The media is no longer available',
    responseStatus3: 'The media is no longer available',
    responseStatus4: 'The media is no longer available',
    responseStatus5: 'Pending admin approval',
    responseStatus6: 'Pending transcript',
    responseStatus7: 'Published unlisted',
    tokenStatus0: 'Published',
    tokenStatus1: 'Hidden by admin',
    tokenStatus2: 'Hidden by publisher',
    tokenStatus3: 'Hidden by admin',
    filterPostsByAllTime: 'All time',
    filterPostsByLast24h: 'Today',
    filterPostsByLastWeek: 'This Week',
    filterPostsByLastMonth: 'This Month',
    sortPostsByCreatedAt: 'New',
    sortPostsByUpvoteAmount: 'Top',
    sortPostsByUpvoteTime: 'Recently $',
    sortPostsByHot: 'Hot',
    outgoingMessage: 'You:',
    sortPostsByRecentActivity: 'Active',
    editPostSubmitBtn: 'Save Post',
    editPostLabel: 'Edit post',
    editDraftPostLabel: 'Edit draft',
    editPostTitle: 'Edit post',
    areYouSureBlock: 'Are you sure you want to block this user?',
    youAreBlocked: 'You were blocked',
    allType: 'All',
    depositType: 'Deposit',
    cashoutType: 'Cash out',
    withdrawType: 'Cash out',
    tipType: 'Tip',
    supercommentType: 'Super comment',
    transferType: 'Transfer',
    timeTxHistory: 'Time',
    memberTxHistory: 'Member',
    showReactors: 'Show reactors',
    createCommentAreYouSureWantToLeavePrompt: 'Leaving this page will discard your comment. Are you sure you want to leave?',
    createContentAnonymousMessage: {
        comment: 'You are commenting anonymously. Your comment will be visible once approved by an admin',
        post: 'You are posting anonymously. Your post will be visible once approved by an admin',
        createPublicPostButton: 'Post with your profile',
    },
    quickCommentInput: {
        placeholder: 'Write a comment',
    },
    commentBox: {
        notFound: 'Comment not found',
        createPostComment: {
            statusButton: 'Status',
        },
    },
    createAnonymousPostOrComment: {
        save: {
            successTitle: 'Success',
            successMessage: 'Your {{ postOrComment }} has been submitted for approval. You can check the status in the following link:',
            statusButton: 'Ok',
        },
    },
    createApprovalRequiredPost: {
        save: {
            successTitle: 'Success',
            successMessage: 'Your {{ postOrComment }} has been submitted for approval.\nA notification will be sent to you when it is approved or rejected.',
            statusButton: 'Status',
        },
    },
    comment: {
        status: {
            '1': 'Hidden by admin',
            '2': 'Hidden by publisher',
            '3': 'Hidden by admin',
            '4': 'Hidden by admin',
            '5': 'Pending admin approval',
        },
        entity: 'comment',
        tipAmount: 'Tipped publisher {{ tipAmount }}',
        commentInput: {
            placeholder: 'Type comment',
        },
    },
    commentsSection: {
        title: 'Comments',
        sortBest: 'Best',
        sortNewest: 'Newest first',
        sortOldest: 'Oldest first',
    },
    postTab: {
        childPosts: {
            title: 'Video Replies',
        },
    },
    parentPostCard: {
        label: 'Response to:',
    },
    commentSortSelector: {
        label: 'Default comment sort',
        helpTip:
            'Set the default sort order for comments on this story. Readers can still change it. Best = most reactions, Newest = latest first (for live discussions), Oldest = chronological.',
    },
    commentMenuPopover: {
        hide: 'Hide',
        unhide: 'Unhide',
        edit: 'Edit',
        delete: 'Delete',
        report: 'Report',
        showReactors: 'Show reactors',
    },
    superCommentMenuPopover: {
        hide: 'Hide',
        unhide: 'Unhide',
        edit: 'Edit',
    },
    superComments: {
        loadMore: 'Load more',
    },
    manageDraftPost: {
        draft: {
            title: 'Manage Draft Post',
            subtitle: 'Schedule or publish your draft post',
        },
        scheduled: {
            title: 'Manage Scheduled Post',
            subtitle: 'Edit or cancel your scheduled post',
        },
        discard: {
            title: 'Discard Draft',
            subtitle: 'This action will permanently delete your draft post and cannot be undone',
        },
        action: {
            draft: 'Cancel Scheduled Publish',
            draftHelptip: 'Cancels the scheduled post and returns it to draft',
            schedule: 'Schedule Publish',
            reschedule: 'Reschedule Publish',
            publishNow: 'Publish Now',
            publishNowHelptip: 'Publishes the post immediately',
            discardDraft: 'Discard Draft',
            discardDraftHelptip: 'Permanently deletes this draft post',
        },
        validation: {
            invalidScheduledDate: 'Scheduled time must be in the future and within one month',
        },
    },
    audioRecorder: {
        disabled: "Audio recording is coming soon. In the meantime, please use the 'Upload audio' button or try our mobile app",
    },
    videoRecorder: {
        disabled: "Video recording is coming soon. In the meantime, please use the 'Upload video' button or try our mobile app",
    },
    createPostTitle: 'Create a new post',
    createCommunityPostTitle: 'Create a new community post',
    createResponsePostTitle: 'Response to post',
    createPostTitleFieldLabel: 'Post Title',
    createPostTitlePlaceholder: 'Enter title',
    createPostContentField: {
        characterCounter: '{{ value }} Characters',
        wordCounter: '{{ value }} Words',
        label: 'Content',
        cancelUpload: 'Cancel',
        videoUploadSelectText: 'Add video',
        poll: {
            addLabel: 'Add poll',
            removeLabel: 'Remove poll',
        },
        videoUploadingSelectText: 'Uploading..',
        audioUploadSelectText: 'Add audio',
        audioUploadingSelectText: 'Uploading..',
        uploadVideoLabel: 'Upload video',
        uploadAudioLabel: 'Upload audio',
        videoUploading: 'Uploading video..',
        audioUploading: 'Uploading audio..',
        disableDeleteResponseMedia: 'Response media can not be removed. You may remove the entire post instead',
    },
    createPostContentPlaceholder: 'Type your content',
    createPost: {
        submitBtn: 'Publish Post',
        preview: 'Preview',
        cancel: 'Cancel',
        scheduleSubmitBtn: 'Schedule Post',
        enableSyndicateToggle: 'Syndicate post ({{ minChars }} characters minimum)',
        enableScheduleToggle: 'Schedule publish',
        parentPost: 'Responding to:',
        approvePending: {
            alertBoxMsgBold: 'Approval Required',
            alertBoxMsg: 'Your post will be published once approved by an admin.',
        },
        originalPublisher: {
            label: 'Original Publisher',
        },
        responseMediaStep: {
            submitBtn: 'Next',
            mediaError: 'Access to camera/microphone failed.',
            cameraLoading: 'Camera is starting..',
            mediaTypeMenuBar: {
                video: 'Video',
                audio: 'Voice',
            },
            uploadVideoButton: 'Upload video',
            uploadAudioButton: 'Upload audio',
            error: {
                mediaTooLong: 'Media is too long (over 3 minutes)',
            },
        },
        responsePublishStep: {
            uploading: 'Uploading video...',
            publishButton: 'Publish',
        },
        selectFromDrafts: 'Load Draft',
        discardDraft: 'Discard Draft',
        discardDraftModal: {
            title: 'Discard Draft',
            subtitle: 'This action will permanently delete your draft post and cannot be undone. Are you sure you want to continue?',
            confirmButton: 'Yes, Discard Draft',
        },
        validation: {
            invalidTitle: 'Invalid title',
            invalidContent: 'Please add some content to your post',
            invalidFlair: 'Please choose at least one topic',
            invalidScheduledDate: 'Scheduled time must be in the future and within one month',
        },
        postKind: {
            label: 'Post Type',
            placeholder: 'Select post type',
            story: 'Story',
            community: 'Community post',
        },
        excerpt: {
            label: 'Excerpt',
            placeholder: 'Write a compelling hook for your story (up to 300 characters), or let AI create one...',
            aiGenerate: 'Generate with AI',
            aiGenerateHelpTip: 'Write your article first for best results. AI will create a compelling excerpt that enhances your headline and hooks readers.',
            helpTip: "Appears in search results and link previews. If left blank, we'll use the opening of your story.",
            comingSoon: 'Coming soon',
        },
        heroImage: {
            label: 'Hero image',
            helpTip:
                'This image will appear in the hero section of the article page. When this post is featured, it will also serve as the header image on the channel page. For best results, use a landscape-oriented image with a recommended aspect ratio of 16:9, 21:9, or 3:2.',
        },
        featuredImage: {
            label: 'Featured image',
            helpTip: 'This image will be used in channel feed post cards and in link previews. for best results, use a square image with a 1:1 aspect ratio.',
        },
        imageMetadata: {
            captionLabel: 'Caption',
            captionPlaceholder: 'Enter image caption...',
            altLabel: 'Alt Text',
            altPlaceholder: 'Describe the image for accessibility...',
            creditLabel: 'Credit',
            creditPlaceholder: 'Photo credit or source...',
        },
        draft: {
            saving: 'Saving draft...',
            saved: 'Draft saved',
            failed: 'Failed to save draft',
        },
        poll: {
            optionsLabel: 'Poll Options',
            titleLabel: 'Poll title',
            titlePlaceholder: 'Ask something (optional)',
            addOptionLabel: 'Add a choice (optional)',
            removeLabel: 'Remove poll',
            optionPlaceholder: 'Option {{ number }}',
        },
    },
    postContent: {
        expendButton: 'Read More',
    },
    createPostBusyUploadingVideo: 'Busy uploading another video {{ tokenName }}',
    footerFaqLink: 'FAQ',
    termsOfUseLink: 'Terms of Use',
    footerPrivacyPolicyLink: 'Privacy Policy',
    Published: 'Published',
    hidePostLabel: 'Hide post',
    unhidePostLabel: 'Unhide post',
    deletePostLabel: 'Delete post',
    newPostButton: 'New Post',
    backToPostLink: 'Back to post',
    backToCommunityPage: 'Back to community page',
    directMessage: {
        title: 'Direct Message',
        noMessages: 'No messages yet',
    },
    seeAll: 'See all',
    dmDefault: 'Aa',
    sortTokensByCreatedAt: 'Creation date',
    sortTokensByCashierBalance: 'Cashier balance',
    sortTokensByNumberOfHolders: 'Number of members',
    'voting rate': 'voting rate',
    viewDeletedPostsLabel: 'View hidden posts',
    draftPostSelection: {
        userDraft: 'My Drafts',
        userScheduled: 'My Scheduled',
        draft: 'All Drafts',
        scheduled: 'All Scheduled',
        premiumDraft: 'Premium Drafts',
        premiumScheduled: 'Premium Scheduled',
        communityDraft: 'Community Drafts',
        communityScheduled: 'Community Scheduled',
    },
    hideDeletedPostsLabel: 'Hide hidden posts',
    viewPendingPostsLabel: 'View pending posts',
    hidePendingPostsLabel: 'Hide pending posts',
    viewPendingCommentsLabel: 'View pending comments',
    hidePendingCommentsLabel: 'Hide pending comments',
    Continue: 'Continue',
    'token holders': 'members',
    'cashier balance': 'cashier balance',
    balanceCardTokenCashierBalanceLabel: 'Cashier balance',
    balanceCardTokenPriceLabel: 'Community token',
    balanceCardTokenHoldersLabel: 'Members',
    'Buy token': 'Deposit',
    'Token holders': 'members',
    poll: {
        anotherSubmitButton: 'Start another poll',
        successMessage: 'Your poll was successfully created.',
        addOptionLabel: 'Add a choice (optional)',
        optionFieldLabel: 'Choice {{ index }}',
        optionPlaceholder: 'Type option {{ index }}',
        optionRemove: 'Remove',
        submitButton: 'Start a poll',
        questionFieldLabel: 'Question',
        questionPlaceholder: 'Ask something',
        title: 'New Poll',
        createButton: 'Create a new poll',
    },
    deleteMessage: 'Delete message',
    fiatInProviderLabel: 'Deposit with {{ provider }}',
    create: 'Create',
    followersModal: {
        followersTab: 'Followers ({{amount}})',
        followingsTab: 'Following ({{amount}})',
    },
    useMax: 'Use Max',
    bbsTokenListItem: {
        totalMembers_one: '{{ count }} member',
        totalMembers_other: '{{ count }} members',
        funds: '{{ funds }} community funds',
        balanceLabel: 'Your reputation:',
        visitButton: 'Visit',
    },
    authModalTitle: 'Welcome to {{ displayName }}',
    authModalSubtitle: 'Sign up to join the discussion',
    authModalLoginTitle: 'Welcome back',
    backToSignInProvidersLink: 'Login another way',
    backToChooseLoginUserLink: 'Login with different user',
    signInWithEmailTitle: 'Login with email',
    signInWithEmailButton: 'Or, you can sign up/login with Email',
    thnPrintSubscriptionLogin: 'Print Subscribers Click Here',
    signInWithEmailFieldLabel: 'Email address',
    signInWithEmailPlaceholder: 'Email address',
    signInWithEmailSubmitButton: 'Email verification',
    signInWithEmailInvalidEmail: 'Invalid email address',
    signInWithEmailLinkPageTitle: 'Loading..',
    signInWithEmailSentTitle: 'Check your email',
    signInWithEmailSentSubtitle: 'Tap the link in the email we sent you to complete registration.',
    changePasswordTitle: 'Change password',
    changePasswordSubtitle: 'Change password and sign in to join the discussion',
    changePasswordSentTitle: 'Check your email',
    changePasswordSentSubtitle: 'We have sent you an email with a link to change your password.',
    forgotPasswordLink: 'Forgot your password?',
    forgotPasswordLabel: 'Forgot your password? You can always change it in your profile menu',
    dropzoneInstructions: 'Click to browse or drag and drop',
    createTokenInitialAboutValue: '',
    createTokenNameHelpTip:
        'Channel symbol would be your unique identifier, used in your channel URL and as the symbol for your community currency. The channel symbol cannot be changed in the future.',
    createTokenAreYouSureWantToLeavePrompt: 'You have unsaved changes, are you sure you want to leave?',
    sendTokenTitle: 'Send',
    withdrawBackedToken: {
        successSubmit: 'Withdraw again',
        successMsg: '{{ tokenAmount }} {{ tokenName }} was successfully withdrawn to {{ withdrawTo }}.',
        withdrawOptionsLabel: 'Withdraw to',
        modalTitle: 'Withdraw {{ backedToken }}',
        amountFieldLabel: '{{ backedToken }} Amount',
        amountPlaceholder: 'Type amount',
        submitButton: 'Withdraw',
        coinbaseOption: {
            description: 'Best for small amounts (subject to [Defibox](https://defibox.io/pool-market-details/1705) fees and conversion rate)',
            memoPlaceholder: 'Memo (Destination Tag)',
        },
        ethWalletOption: {
            title: 'ETH Wallet',
            description: 'Best for large amounts',
            minAmount: 'Min amount: {{ minAmount }}',
            feeCost: 'Fee cost: {{ fee }} (used to cover Ethereum gas fees)',
            withdrawToPlaceholder: 'ETH Address',
        },
        eosWalletOption: {
            title: 'EOS Wallet',
            description: 'Best for small amounts',
            withdrawToPlaceholder: 'EOS Address',
            memoPlaceholder: 'Memo',
            convertTo: {
                title: 'Convert to:',
                backedToken: '{{ backedToken }}',
                eos: 'Convert to EOS (Conversion fee may apply)',
            },
        },
    },
    activityTab: {
        tabs: {
            txLog: 'Activity',
            cashierQueue: 'Cashier Queue',
            report: 'Reports',
            revenue: 'Revenue',
            modAct: 'Moderation',
        },
        cashierQueueTab: {
            itemNotFoundOnQ: 'Item was already canceled, please wait 3 min for it to be removed from the list',
            totalAmountLabel: 'Total amount:',
            cancelSellTokenConfirmationModal: {
                title: 'Are you sure?',
                subtitle: 'You are about to cancel the queue at index {{ index }}. It will take 3 min for it to be removed from the list.',
                index: 'Index: ',
            },
            tableHeader: {
                id: '#',
                index: 'INDEX',
                member: 'MEMBER',
                cashout: 'CASHOUT',
                receive: 'RECEIVE',
                actions: '',
            },
        },
        modActivityTab: {
            itemNotFoundOnQ: 'Item was already canceled, please wait 3 min for it to be removed from the list',
            totalAmountLabel: 'Total amount:',
            tableHeader: {
                createdAt: 'TIME',
                actionType: 'ALL',
                actionValue: 'UNDO',
                tipAmount: 'AMOUNT',
                moderatorDisplayName: 'ADMIN',
                username: 'MEMBER',
                postOrComment: 'POST/COMMENT',
                reason: 'REASON',
                actions: '',
            },
            actionType: {
                All: 'All',
                BlockChat: 'Block chat',
                BanUser: 'Ban',
                DeletePost: 'Hide post',
                DeleteComment: 'Hide comment',
                DeleteSuperComment: 'Hide super comment',
                WhitelistUser: 'Make partner',
                Moderator: 'Make admin',
                Tip: 'Super Comment',
            },
            actionTypeValue: {
                All: 'All',
                BlockChat0: '',
                BlockChat1: 'Unblock',
                BanUser1: '',
                BanUser0: 'Unban',
                DeletePost0: '',
                DeletePost1: 'Unhide',
                DeleteComment0: '',
                DeleteComment1: 'Unhide',
                WhitelistUser1: '',
                WhitelistUser0: 'Unmake',
                Moderator0: 'Unmake',
                Moderator1: '',
                Tip0: '',
                Tip1: '',
            },
        },
    },

    buyToken: {
        buyTokenFormOption: {
            description: '{{ backedToken }} balance',
        },
        buyTokenOptions: {
            submit: 'Continue',
            close: 'Done',
            cancel: 'Cancel',
        },
        eosWalletOption: {
            title: 'EOS transfer',
            instructions: 'To buy this token, send EOS\n\nto address: "{{ fiatInWalletAddress }}"\n\n with memo: "{{ memo }}"',
        },
        cashingTokenOption: {
            submitButton: 'Continue',
            description: 'From community pool',
            amountPlaceholder: 'Type amount',
        },

        tokenPoolDepositOption: {
            submitButton: 'Continue',
            description: 'To community pool',
            amountPlaceholder: 'Type amount',
        },
        priceDiffTooHighAlert: 'The market price of BBS tokens is currently volatile. It is recommended to wait a few minutes before cashing out.',
        estRateLabel: 'Est. Rate:',
        submitButton: 'Deposit',
        outputAmountFieldLabel: 'You will receive',
        amountFieldLabel: '{{ tokenName }} Amount',
        amountPlaceholder: 'Type amount',
        outputAmountPlaceholder: 'You will receive',
        modalTitle: 'Deposit {{ tokenName }}',
        successMsg: '{{ tokenAmount }} {{ tokenName }} was successfully deposited.\nPlease allow up to 3 minutes for the deposit to reflect in your balance.',
    },
    fiatInSuccess: {
        title: 'Success!',
        message: 'Your request is completed, it will take up to 3 min to see the new balance.',
        txIdMessage: 'Transaction id: ',
    },
    sellToken: {
        systemFeeHelpTip: 'The fee goes to the the operator and the network DAO.',
        estimateRate: 'Est. Rate (1:{{ backedTokenRate }} {{ backedToken }}):',
        systemFee: 'System Fee ({{ fee }}) :',
        amountFieldLabel: 'Amount',
        amountPlaceholder: 'Type amount (minimum {{ minCashoutAmount }})',
        bellowMinCashoutAmount: 'The minimum cash out amount is {{ minCashoutAmount }}',
        outputAmountFieldLabel: 'You will receive',
        outputAmountPlaceholder: 'You will receive',
        successMsg: 'Your request for cashing out {{ tokenAmount }} {{ tokenName }} was successfully sent.',
        modalTitle: 'Cash out {{ tokenName }} to {{ backedToken }}',
        submitButton: 'Cash out',
    },
    flair: 'Topics',
    deleteFlair: 'Delete',
    editFlair: {
        maxFlairs: 'Up to 10 topics can be used',
        flairsLimits: 'Only numbers, upper and lowercase letters. No special characters',
        flairText: 'Topic text',
        editFlairSubtitle: 'Update the topics for this post',
        title: 'Edit topics',
        newFlairId: 'Will be used as "{{ flairId }}" in the URL',
    },
    addNewFlair: '+ Add new topic',
    updateFlair: 'Update',
    saveFlair: 'Save',
    cancelFlair: 'Cancel',
    deleteFlairWarning: 'Are you sure you want to delete {{ flairName }}?',
    failedToCreateFlair: 'Failed to create topic',
    editFlairsList: 'Edit topic list',
    manageFlairs: 'Manage topics',
    sellTokenBelowMinAmount: 'Minimum sale is {{ minAmount }} {{ tokenName }}',
    invalidTokenName: 'Name must be 5-7 uppercase characters',
    invalidTitle: 'Invalid title',
    invalidFlair: 'Invalid topics',
    videoInvalidType: 'Unsupported file type',
    audioInvalidType: 'Unsupported file type',
    videoTooLong: 'Video is too long (over 21 minutes)',
    videoFileTooLarge: 'File too large, the maximum file size you can upload is {{ maxSizeMb }} MB',
    cannotReadFile: 'Cannot read file - upload was aborted',
    invalidName: 'Invalid name',
    invalidMemo: 'Invalid memo',
    invalidUsername: 'Username must be 3-20 characters',
    invalidEthereumAddress: 'Invalid Ethereum address',
    usernameReserved: 'User with this name already exists',
    invalidPassword: 'Minimum 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character',
    aboveMaxAmount: 'Maximum amount: {{ maxAmount }}',
    belowMinAmount: 'Minimum amount: {{ minAmount }}',
    loginInvalidUsername: 'Invalid username',
    loginFailedTooManyTimes: 'Login failed too many times, you can try again in 1 hour',
    loginInvalidPassword: 'invalid credentials',
    invalidConfirmPassword: 'Password and confirm password do not match',
    loginUsernameFieldLabel: 'Username',
    loginUsernamePlaceholder: 'Enter username',
    loginPasswrodFieldLabel: 'Password',
    loginPasswrodPlaceholder: 'Enter password',
    createAccount: {
        termsOfUseField: 'I agree to the terms of use and I am 18 or older.',
    },
    createAccountUsernameFieldLabel: 'Username',
    createAccountUsernamePlaceholder: 'Choose username',
    createAccountPasswordFieldLabel: 'Password',
    createAccountPasswordPlaceholder: 'Choose password',
    createAccountConfirmPasswordFieldLabel: 'Confirm password',
    createAccountConfirmPasswordPlaceholder: 'Confirm password',
    createTokenNameFieldLabel: 'Channel Symbol (5-7 English Letters)',
    editToken: {
        titleFieldLabel: 'Token page title',
        titlePlaceholder: 'Name your token page',
        nameFieldLabel: 'Channel Symbol (5-7 English Letters)',
        namePlaceholder: 'Name your token',
        aboutFieldLabel: 'Token page description',
        aboutPlaceholder: 'Tell everyone what your token is about',
        imageLabel: 'Token page image',
        coverImageLabel: 'Token page cover image',
    },
    pendingCommentList: {
        success: {
            approve: {
                title: 'Comment approved successfully',
                message: 'It can now be viewed in the following link:',
            },
            delete: {
                title: 'Deleted',
                message: 'Comment has been successfully deleted',
            },
        },
    },

    searchPage: {
        title: 'Search results',
        type: {
            posts: 'Posts',
            comments: 'Comments',
            users: 'Members',
            tokens: 'Channels',
        },
        tokenFilter: {
            allTokens: 'All Channels',
        },
        domainFilter: {
            allDomains: 'All Channels',
        },
        sortBy: {
            label: 'Sort by',
            bestMatch: 'Best match',
            totalReactions: 'Reactions',
            comments: 'Comments',
            totalReplies: 'Replies',
            publishTime: 'Date',
            totalPosts: 'Total posts',
            creationDate: 'Creation date',
            numberOfMembers: 'Number of members',
        },
        postsRange: {
            day: 'Past 24h',
            week: 'Past Week',
            month: 'Past Month',
            year: 'Past Year',
            allTime: 'All Time',
        },
        noResults: {
            title: 'No results found',
            subtitle: 'No results found for "{{ query }}"',
        },
        userResultItem: {
            joinDate: 'Joined at {{ date }}',
            joinedCommunities: 'Member of: {{ joinedCommunities }}',
        },
        tokenResultItem: {
            creationDate: 'Created at {{ date }}',
            numMembers_one: '{{ countFormated }} member',
            numMembers_other: '{{ countFormated }} members',
            totalPosts_one: '{{ countFormated }} post',
            totalPosts_other: '{{ countFormated }} posts',
        },
    },
    searchInput: {
        placeholder: 'Search',
    },
    userSearchInput: {
        placeholder: 'Type username',
    },
    sendTokenAmountFieldLabel: 'Amount',
    sendTokenAmountPlaceholder: 'Type amount',
    sendTokenToFieldLabel: 'To',
    sendTokenToPlaceholder: 'Type username',
    sendTokenMessageFieldLabel: 'Message',
    sendTokenMessagePlaceholder: 'Type message',
    sendTokenSuccessSuccessMsg: '{{ tokenAmount }} {{ tokenName }} was successfully sent to {{ to }}.',
    sendTokensReceiverIsSameAsSelfError: 'You cannot send tokens to yourself',
    sendTokensReceiverDoesNotExistError: 'Receiver does not exist',
    invalidWithdrawTo: 'Invalid account',
    invalidToAccount: 'Invalid account',
    invalidToAccountEqualFrom: 'You can not send tokens to yourself',
    To: 'To',
    price: 'price',
    buyButton: 'Deposit',
    Sell: 'Sell',
    'Your balance': 'Your balance',
    Cancel: 'Cancel',
    close: 'Close',
    Save: 'Save',
    Change: 'Change',
    Send: 'Send',
    send: 'Send',
    cancel: 'Cancel',
    About: 'About',
    Admin: 'Admin',

    mainMenu: {
        forumPicker: 'Picker',
        search: 'Search',
        myBoards: 'My Channels',
        profileSection: {
            viewProfileButton: 'View profile',
        },
        networkAdminDashboard: 'Network Admin Dashboard',
        stakeRtb: 'Stake RTB',
        accountSection: {
            title: 'My Account',
            changePassword: 'Change password',
            logout: 'Logout',
            editProfile: 'Edit profile',
            accountSettings: 'Account settings',
            mergeAccounts: 'Merge accounts',
        },
    },
    header: {
        loginButton: 'Login',
    },
    'Sign-up': 'Sign up',
    loginSubmitButton: 'Log in',
    tokenAlreadyExists: 'Channel with this name already exists',
    usernameAlreadyExists: 'User with this name already exists',
    backToHome: 'Back to home page',
    tokenListLoadMoreBtn: 'Show more',
    imageUploadFailed: 'Image upload failed',
    messageFailedBlocked: 'Message failed, you were blocked by {{ userName }}',
    messageTooLong: 'Message too long, must be less than 400 characters',
    totalComments_one: '{{ count }}',
    totalComments_other: '{{ count }}',
    totalReplies_one: '{{ count }} reply',
    totalReplies_other: '{{ count }} replies',
    balanceHoldersOrderBy: 'Reputation',
    totalFollowersHoldersOrderBy: 'Followers',
    createdAtHoldersOrderBy: 'Date joined',
    orderHoldersBy: 'Sort by {{ orderByFilter }}',
    allUsersOrderBy: 'All',
    moderatorUsersOrderBy: 'Moderator',
    partnerUsersOrderBy: 'Partner',
    bannedUsersOrderBy: 'Banned',
    noSortAvailble: 'No sort available',

    reactionsList: {
        emptyState: 'No reactions yet.',
        tabTitle: {
            thumbUp_one: '{{ count }} Agree',
            thumbUp_other: '{{ count }} Agrees',
            thumbDown_one: '{{ count }} Disagree',
            thumbDown_other: '{{ count }} Disagrees',
        },
    },
    transakExchangeScreenTitle: 'Buy {{ tokenName }}',
    copyToClipboardSuccessMessage: 'Copied to clipboard',
    shareButton: {
        share: 'Share',
        linkCopySuccess: 'Link copied',
    },
    balanceIndicator: {
        label: {
            link: 'Available: {{ balance }}',
            useMax: 'Available: {{ balance }}',
        },
        labelInFiat: {
            link: 'Available: {{ balance }}',
            useMax: 'Available: {{ balance }} in {{ tokenName }}',
        },
    },
    notificationPage: {
        title: 'Notifications',
        goBackLink: 'Go back',
        loadMoreBtn: 'Show more',
        emptyStateMsg: 'There are no notifications',
        tabs: {
            notifications: 'NOTIFICATIONS',
            messages: 'MESSAGES',
        },
        settingsButton: 'Settings',
        notificationsActions: {
            markAsReadUnread: 'Mark as read/unread',
            remove: 'Remove this notification',
            dontShowType: "Don't show this type of notification again",
        },
        typeFilter: {
            all: 'All Notifications',
            comments: 'Comments',
            tags: 'Tags',
            promotions: 'Promotions',
            reactions: 'Reactions',
            tips: 'Tips',
            receivedTokens: 'Receiving tokens',
            withdraw: 'Withdraw updates',
            follow: 'Follow',
        },
    },
    holdersTab: {
        tableHeader: {
            name: 'Name',
            followers: 'Followers',
            // 'reputation': 'Reputation',
            joined: 'Joined',
        },
    },
    notificationSettings: {
        title: 'Notification settings',
        subtitle: 'Notifications you will receive',
        backLink: 'Back to notifications',
        titles: {
            follow: 'Follow',
            comments: 'Comments',
            tips: 'Tips',
            tags: 'Tags',
            promotion: 'Promotion',
            reactions: 'Reactions',
            posts: 'New post',
            directMessage: 'Direct message',
            receivingTokens: 'Receiving tokens',
            withdrawUpdates: 'Withdraw updates',
        },
        options: {
            newCommentOnPost: 'A new comment on your post',
            newReplyOnComment: 'A new reply on your comment',
            newReplyOnThread: 'New reply to thread',
            taggedOnComment: 'Tagged in a comment',
            taggedOnPost: 'Tagged in a post',
            newUpvoteOnPost: 'Someone promoted your post',
            outUpvoted: 'A new promoter on a post I promoted',
            receivedTokens: 'Received tokens',
            receivedCashable: 'Received cashable',
            newReactionPost: 'New reaction to post',
            newReactionComment: 'New reaction to comment',
            newReactionReply: 'New reaction to reply',
            tipOnComment: 'Tipping on a comment',
            tipOnPost: 'Tipping on a post',
            newDirectMessage: 'New direct message',
            withdrawFullfilledMessage: 'Withdraw updates',
            withdrawQueuedMessage: 'withdrawQueuedMessage',
            withdrawCancelledMessage: 'withdrawCancelledMessage',
            receiveTokenOwnership: 'receiveTokenOwnership',
            changedTokenOwnership: 'changedTokenOwnership',
            signUp: 'signUp',
            joinCommunity: 'joinCommunity',
            followPostMember: 'Published post in a channel you are a member of',
            followPostNotMember: 'Published post in a channelyou are not a member of',
            followCommentMember: 'Published comment in a channel you are a member of',
            followCommentNotMember: 'Published comment in a channel you are not a member of',
            followUpvoteMember: 'Promoted a post in a channel you are a member of',
            followUpvoteNotMember: 'Promoted a post in a channel you are not a member of',
            followTipOnPostMember: 'Tipped a post in a channel you are a member of',
            followTipOnPostNotMember: 'Tipped a post in a channel you are not a member of',
            followTipOnCommentMember: 'Tipped a comment in a channel you are a member of',
            followTipOnCommentNotMember: 'Tipped a comment in a channel you are not a member of',
            newFollower: 'New follower',
            newPost: 'New post',
            newResponse: 'New response to post',
            newResponseOnThread: 'New response on a thread',
        },
    },
    notificationMessage: {
        followTipOnCommentMember: 'tipped the comment "{{commentContent}}".',
        followTipOnCommentNotMember: '{{senderName}} tipped the comment "{{commentContent}}".',
        followTipOnCommentMemberTippedUserName: 'tipped "{{username}}" for their comment "{{commentContent}}".',
        followTipOnCommentNotMemberTippedUserName: '{{senderName}} tipped "{{username}}" for their comment "{{commentContent}}".',
        followTipOnPostMember: '{{senderName}} tipped the publisher of the post "{{postTitle}}".',
        followTipOnPostNotMember: '{{senderName}} tipped the publisher of the post "{{postTitle}}".',
        followUpvoteMember: 'promoted post "{{postTitle}}".',
        followUpvoteNotMember: 'promoted post "{{postTitle}}".',
        newFollower: 'started following you.',
        newResponse: 'Published a new response to your post "{{postTitle}}"',
        newResponseOnThread: 'Published a new response "{{postTitle}}"',
        followPostMember: 'published a new post "{{postTitle}}" in "{{tokenName}}".',
        followCommentMember: '{{followingUserName}} commented on a post "{{postTitle}}" in "{{tokenName}}".',
        followPostNotMember: 'published a new post "{{postTitle}}" in "{{tokenName}}".',
        followCommentNotMember: '{{followingUserName}} commented on a post "{{postTitle}}" in "{{tokenName}}".',
        newUpvoteOnPost: 'promoted your post "{{ postTitle }}" for "{{ lastPrediction }} {{ tokenName }}" reputation',
        outUpvoted: 'Is now the promoter of the post "{{ postTitle }}", you got back "{{ prevUpvoteCost }} {{ tokenName }}" and earned "{{ prevUpvoterProfit }} {{ tokenName }}"',
        failedUpvote: 'We’re sorry, your promotion for "{{ postTitle }}" has failed. Click here to try again',
        newDirectMessage: 'sent you a message',
        newDirectMessageWithMessage: 'sent you a message: "{{ message }}"',
        newCommentOnPost: 'commented on your post "{{ postTitle }}"',
        newReactionPost: '{{ prefix }} reacted to your post "{{ postTitle }}"',
        newReactionComment: '{{ prefix }} reacted to your comment "{{ commentContent }}"',
        newReactionReply: '{{ prefix }} reacted to your reply "{{ commentContent }}"',
        newReplyOnComment: 'replied to your comment "{{ commentContent }}"',
        taggedOnComment: 'tagged you in a comment "{{ commentContent }}"',
        newReplyOnThread: 'new replies in your thread on "{{ commentContent }}"',
        receivedTokens: 'sent you {{ amount }} {{ tokenName }}',
        joinCommunity: 'Welcome to {{ tokenName }}',
        receivedCashable: 'You received {{ amount }} payment from {{ username }}',
        tipOnComment: 'tipped you with {{ amountReceived }} for your comment on "{{ postTitle }}"',
        superComment: 'Commented and tipped you {{ amountReceived }} - on your post "{{ postTitle }}"',
        superReply: 'Commented and tipped you {{ amountReceived }} - on your comment "{{ commentContent }}"',
        tipOnPost: 'tipped you with {{ amountReceived }} for your post "{{ postTitle }}"',
        receivedTokensWithMemo: 'sent you {{ amount }} {{ tokenName }} with a note saying “{{ memo }}”',
        withdrawFullfilledMessage: 'Your request to cash out {{ amount }} {{ tokenName }}" was successfully fulfilled',
        withdrawQueuedMessage: 'Your request to cash out {{ amount }} {{ tokenName }}" was successfully queued',
        withdrawCancelledMessage: 'Your request to cash out {{ amount }} {{ tokenName }}" was canceled',
        signUp: 'Welcome to "{{ displayName }}"',
        receiveTokenOwnership: 'transferred the ownership of "{{ tokenName }}" community to you',
        changedTokenOwnership: 'transferring the ownership of "{{ tokenName }}" community to {{ receiverName }} was completed successfully',
        newPost: 'published a new post "{{ postTitle }}"',
        pendingContent: 'There are pending comments/posts waiting for your approval',
        approvePosttrue: 'Your post "{{ postTitle }}" was approved by admin',
        approvePostfalse: 'Your post "{{ postTitle }}" was deleted by admin',
        failedTranscription: 'Adding a title to your post failed, to publish the post please edit and add a title',
    },
    stakeBBS: 'Staking Rewards',
    thisAccountWasForwardedTo: 'This account was forwarded to primary account {{ account }}',
    newUpvoteOnPostTotalProfit: '${{ profitUsd }} total income',
    newReactionNotificationReactorsPrefix_one: '{{ reactors }} and {{ count }} other',
    newReactionNotificationReactorsPrefix_other: '{{ reactors }} and {{ count }} others',
    userCard: {
        stakingRewardsButton: 'Staking Rewards',
        bannedLabel: 'Banned!',
        bannedNotificationMyUser: 'You were banned from this community',
        bannedNotification: '{{ username }} was banned from this community',
        backedTokenBannedNotificationMyUser: 'Your BBS balance is frozen',
        backedTokenBannedNotification: "{{ username }}'s BBS balance is frozen",
        tokenBalanceLabel: 'Balance',
        tokenBalancesLabel: 'Reputation',
        cashOut: 'Cash out',
        cashoutDisabled: 'Only partners can cash out',
        buy: 'Deposit',
        send: 'Send',
        deposit: 'Deposit',
        permissionButton: {
            banUser: 'Ban',
            approveSell: 'Make Partner',
            approveModerator: 'Approve admin',
            blockUserFromDM: 'Block DM',
            muteTagging: 'Mute tagging',
            adminSettings: 'Admin settings',
        },
        creditBalance: 'Cashable',
        creditBalanceLabel: 'Cashable:',
        creditBalanceHelpTip: 'The earnings generated from published posts that can be converted to BBS tokens',
        backedTokenBalance: '{{ backedToken }} Balance:',
        backedTokenWithdraw: 'Withdraw',
    },
    adminSettings: {
        title: 'Admin settings',
        subtitle: 'Please select the permissions you grant this member',
        permissionSettings: {
            userName: 'Username',
            approveAdmin: 'Approve admin',
            banUser: 'Ban user',
            whitelistUser: 'Approve partner',
            blockChat: 'Block from chat',
            editBBS: 'Edit Channel',
            hideContent: 'Content moderation - Community',
            hidePremiumContent: 'Content moderation - Premium',
            pinPost: 'Pin post',
            viewUserEmail: "View member's email",
            changePermissionRestricted: 'You do not have permission to change this permission setting',
        },
        closeBtn: 'Done',
        pending: {
            pendingPosts: 'Pending posts',
            pendingComments: 'Pending comments',
            deletedPosts: 'Hidden posts',
            scheduledPosts: 'Scheduled posts',
            draftPosts: 'Draft posts',
        },
        moderators: {
            modAct: 'Moderator Activity',
            permissions: 'Moderator Permissions',
        },
        viewPendingContent: 'Manage pending content',
        moderatorsTables: 'Moderator panel',
        editBoard: 'Edit Channel',
        editBBS: {
            title: 'Edit Channel',
            transferOwnership: 'Transfer ownership',
            editTokenImageLabel: 'Icon',
            editTokenCoverImageLabel: 'Cover Image',
            editTokenCoverImageHelpTip: 'This cover image will be presented when sharing the channel and in the newsletter header.',
            editTokenLogoImageLabel: 'Header Logo',
            editTokenLogoImageHelpTip:
                "This image will be displayed in the header when viewing channel pages. It should be a rectangle image with a transparent background (.png), cropped tightly to the logo's edges.",
            editTokenTitleFieldLabel: 'Channel Name',
            editTokenTitlePlaceholder: 'Name your channel',
            editTokenInviteTitleFieldLabel: 'Invitation Title',
            editTokenInviteTitleHelptip: 'A custom title to be used when sharing your channel using the invite button.',
            editTokenInviteTitlePlaceholder: 'Enter title here',
            editTokenInviteTextFieldLabel: 'Invitation Text',
            editTokenInviteTextHelptip: 'A custom text to be used when sharing your channel using the invite button.',
            editTokenInviteTextPlaceholder: 'Enter text here',
            editTokenNewOwnerFieldLabel: 'Transfer Ownership',
            editTokenNewOwnerPlaceholder: 'Type username',
            editTokenNamePlaceholder: 'Name your channel',
            editTokenAboutFieldLabel: 'About your Channel',
            editTokenAboutPlaceholder: 'Tell everyone what your channel is about',
            approvePostsDesc: 'Posts require moderator approval',
            defaultCommentSortLabel: 'Default comment sort order',
            defaultCommentSortHelpTip:
                'Sets the default sort order for all comments in your channel. Partners can override this per-story. Best = most reactions, Newest = latest first (good for live threads), Oldest = chronological order.',
        },
        flairs: 'Topics',
    },
    userPage: {
        activityTab: 'Activity',
        commentsTab: 'Comments',
        publishedPostsTab: 'Published',
        userDraftTab: 'Draft',
        userScheduledTab: 'Scheduled',
        userDeletedTab: 'Hidden',
        forwardedAccountNotice: 'Notice: this member has forwarded the account and now active under',
        mainAccountNotice: 'Notice: Primary account for',
        joinedAt: 'Joined at {{ joinDate }}',
        followingStats: '{{ followers }} followers · {{ followings }} followings',
    },
    createPassword: {
        title: 'Create Password',
        subtitle: 'The action you wish to perform requires a password. Please create password for your account and save it for future use.',
        passwordFieldLabel: 'Password',
        passwordPlaceholder: 'Choose password',
        confirmPasswordFieldLabel: 'Confirm password',
        confirmPasswordPlaceholder: 'Confirm password',
        submit: 'Save',
    },
    forgotPassword: {
        title: 'Change Password',
        subtitle: 'Change password and sign in to join the discussion',
        displayNameFieldLabel: 'Username',
        usernamePlaceholder: 'Choose password',
        passwordFieldLabel: 'New password',
        passwordPlaceholder: 'Choose password',
        confirmPasswordFieldLabel: 'Confirm password',
        confirmPasswordPlaceholder: 'Confirm password',
        submit: 'Change password',
    },
    enterPassword: {
        title: 'Enter Password',
        subtitle: 'The action you wish to perform requires a password. Please enter your account password.',
        passwordFieldLabel: 'Password',
        passwordPlaceholder: 'Enter password',
        submit: 'Submit',
    },
    editProfileTitle: 'Edit profile',
    editProfileImageLabel: 'Profile picture',
    editProfileNameFieldLabel: 'Name',
    editProfileNamePlaceholder: 'Enter name',
    editProfileAboutFieldLabel: 'About',
    editProfileAboutPlaceholder: 'Write a short bio about yourself',
    editProfileTitleFieldLabel: 'Title',
    editProfileTitlePlaceholder: 'Write a short title describing yourself',
    editProfileSubmitButton: 'Save',
    pinPostLabel: 'Pin post',
    unPinPostLabel: 'Unpin post',
    syndicatePostLabel: 'Syndicate post',
    desyndicatePostLabel: 'Desyndicate post',
    pollOptions: {
        totalUsers_one: '{{ count }} User',
        totalUsers_other: '{{ count }} users',
        // 'totalTokens_one': '{{ count }} Token',
        // 'totalTokens_other': '{{ count }} {{ tokenName }}'
    },
    postBasicInfo: {
        partnerLabel: 'Partner',
        memberOfLabel: '{{ username }}@{{ communityName }}',
        lastUpdatedAt: 'Updated at {{ date }}',
    },
    postCard: {
        partnerLabel: 'Partner',
    },
    tokenPageHeader: {
        tokenInfoSubtitle: '{{ tokenName }}',
        forumPicker: 'Picker',
    },
    tokenPage: {
        leaderboard: {
            title: 'Leaderboard',
            subtitle: 'All data displayed in this leaderboard table reflects user rankings and statistics for the month of {{ date }}',
            loadMoreButton: 'Load More',
            noDataMessage: 'No leaderboard data available for this month.',
            errorMessage: 'Failed to load leaderboard data. Please try again.',
            columns: {
                rank: '#',
                name: 'Name',
                views: 'Views',
                totalFollowers: 'Total followers',
                newFollowers: 'New followers',
                daysActive: 'Days Active',
                score: 'Score',
            },
            partner: 'Partner',
        },
        reports: {
            title: 'Reports',
            subtitle: 'Manage and review reports submitted by community members',
            activeFilters: 'Active Filters',
            loadMoreButton: 'Load More',
            noDataMessage: 'No reports found',
            errorMessage: 'Failed to load reports. Please try again.',
            columns: {
                time: 'Time',
                status: 'Status',
                type: 'Type',
                reporter: 'Reporter',
                reported: 'Reported',
                postComment: 'Post/Comment',
                reason: 'Reason',
                // Status filter values
                all: 'All',
                new: 'New',
                done: 'Done',
                rejected: 'Rejected',
                // Type filter values
                user: 'User',
                post: 'Post',
                comment: 'Comment',
                community: 'Community',
            },
        },
        holdersTab: {
            title: 'Members',
            loadMoreButton: 'Load more',
        },
        postsTab: {
            communityPostList: {
                title: '{{ tokenName }} Community',
            },
        },
        createPostInput: {
            leaderboard: 'Leaderboard',
            createCommunity: 'Create new post',
            createStory: 'Create new story',
        },
    },
    tipComment: {
        title: 'Tip that comment!',
        totalTipsLabel: 'Comment Tips: {{ totalTips }} {{ tokenName }}',
        balanceLabel: 'Balance: {{ balance }} {{ tokenName }}',
        description: 'Select the amount of tip you want to reward to the comment publisher to show your appreciation.',
        submitButton: 'Submit',
        tip: 'Tip',
    },
    tipPost: {
        title: 'Tip that post!',
        totalTipsLabel: 'Post Tips: {{ totalTips }} {{ tokenName }}',
        balanceLabel: 'Balance: {{ balance }} {{ tokenName }}',
        description: 'Select the amount of tip you want to reward to the post publisher to show your appreciation.',
        submitButton: 'Submit',
        tip: 'Tip',
    },
    aboutTokenCard: {
        title: 'About {{ tokenName }}',
        adminTitle: 'Owner',
        createdAtTitle: 'Created',
        totalHolders: 'Members',
        totalPosts: 'Posts',
        tokenName: 'Channel Code',
    },
    flairsTokenCard: {
        title: 'Topics',
    },
    connectedAccounts: {
        title: 'Connected Accounts',
        subtitle: 'A link to your social media profile would be featured on your profile',
    },
    connectAccountButton: {
        connect: {
            google: 'Connect Google Account',
            github: 'Connect Github Account',
            twitter: 'Connect Twitter Account',
            facebook: 'Connect Facebook Account',
        },
        unlinkConfirmationTitle: 'Are you sure you want to unlink this account?',
    },

    errors: {
        bannedFromCommunity: 'You were banned from this community',
        insufficientBalance: 'Insufficient balance',
        userCannotTipHimself: 'You cannot tip yourself',
        'auth/popup-closed-by-user': 'Popup closed by user',
        'auth/credential-already-in-use': 'This credential is already associated with a different user account',
        'auth/email-already-in-use': 'The email address is already in use by another account',
        'auth/popup-blocked': 'Popup was blocked by the browser',
        'auth/cancelled-popup-request': 'this operation has been cancelled due to another conflicting popup being opened',
    },

    confirmModal: {
        okButton: 'Ok',
        cancelButton: 'Cancel',
    },

    joinButton: {
        join: 'Join',
        leave: 'Joined',
    },

    discoverMoreBbsButton: 'Discover more',
    shareBbsButton: 'Invite',

    joinToken: {
        title: 'Please join the community',
        text: 'To continue, you must be a member of the community',
    },

    fileTooLarge: 'Image size needs to be less than 1MB',
    leaveTokenModal: {
        title: 'Are you sure?',
        text: 'Are you sure you want to leave the community?',
    },
    selectReasonToReport: 'Select your reason to report this {{ entity }}',
    copiedToClipboard: 'Copied to clipboard',
    banModal: {
        ban: {
            title: 'Ban {{ displayName }}',
            description: 'Select ban timeframe',
            submitButton: 'Next',
            selectTimeframe: {
                '0': 'Always',
                '1': '1 Day',
                '3': '3 Days',
                '7': '1 Week',
            },
            deleteContent: {
                toggleLabel: "Remove the user's posts and comments as well",
                alertBox: "This action will hide all of the user's posts and comments from this channel",
            },
        },
        selectReason: {
            title: 'Select a reason',
            description: 'Select a reason',
        },
    },
    accountSettingsPage: {
        title: 'Account Settings',
        subtitle: 'Customize and manage your account',
        sections: {
            deleteAccount: {
                title: 'Delete Account',
                cautionMessage: 'Proceed with caution',
                message: 'This action cannot be undone, we will completely wipe your data. There is no way to access your account after this action.',
                continueButton: 'Delete Account',
            },
        },
        backLink: 'Back to channel',
    },

    deleteAccountModal: {
        delete: {
            title: 'Delete {{ displayName }}',
            description:
                'Deleting your account will remove all your data from the platform. This action cannot be undone. The deletion process can take up to a month to be completed.',
            submitButton: 'Delete {{ displayName }}',
            confirmEmail: {
                label: 'Confirmation email',
                helpTip: 'Where would you like us to send completion confirmation to?',
                placeholder: 'Type your email',
            },
        },
        success: {
            title: 'Request submited',
            message: 'Your request to delete the account has been successfully submitted.',
        },
    },

    createExternalArticleCommentPage: {
        loadingPostTitle: 'Loading post..',
        status: {
            idle: 'We are getting your comment ready for publication, it will be posted soon.',
            pending: 'We are getting your comment ready for publication, it will be posted soon.',
            success: 'Your comment has been posted successfully.',
            error: 'There was an error posting your comment. Please try again.',
        },
    },

    commentList: {
        loadMoreButton: 'Show More Comments',
        backToTopButton: 'Back to Top',
        post: {
            emptyState: {
                title: 'No comments yet',
                subtitle: 'There are no comments available for this post',
            },
            loadMoreButton: 'Show More Comments',
        },
        comment: {
            loadMoreButton_one: '1 Reply',
            loadMoreButton_other: '{{ count }} Replies',
        },

        user: {
            loadMoreButton: 'Show More Comments',
            emptyState: {
                title: 'No comments found',
                subtitle: 'There are no comments available for this filter',
            },
        },

        pending: {
            loadMoreButton: 'Show More Comments',

            emptyState: {
                title: 'No comments found',
                subtitle: 'There are no comments available for this filter',
            },
        },
    },

    recommendedPostList: {
        title: 'Recommended Posts',
    },

    postList: {
        loadMoreButton: 'Show More Posts',
        backToTopButton: 'Back to Top',
        emptyState: {
            title: 'No posts found',
            subtitle: 'There are no posts available for this filter',
        },
        partner: {
            loadMoreButton: 'More Premium Stories',
            emptyState: {
                title: 'No stories found',
                subtitle: 'There are no stories available for this filter',
            },
        },

        community: {
            loadMoreButton: 'More Community Posts',
            backToTopButton: 'Go to Premium Stories',
            emptyState: {
                title: 'No community posts found',
                subtitle: 'There are no community posts available for this filter',
            },
        },

        user: {
            loadMoreButton: 'Show More Posts',
            emptyState: {
                title: 'No author posts found',
                subtitle: 'There are no author posts available for this filter',
            },
        },

        deleted: {
            loadMoreButton: 'Show More Posts',
            backToTopButton: 'Back to Top',
            emptyState: {
                title: 'No deleted posts found',
                subtitle: 'There are no deleted posts available for this filter',
            },
        },

        pending: {
            loadMoreButton: 'Show More Posts',
            backToTopButton: 'Back to Top',
            emptyState: {
                title: 'No pending posts found',
                subtitle: 'There are no pending posts available for this filter',
            },
            success: {
                approve: {
                    title: 'Post approved successfully',
                    message: 'It can now be viewed [here]({{ postUrl }})',
                },
                delete: {
                    title: 'Deleted',
                    message: 'Post has been successfully deleted',
                },
            },
        },

        draft: {
            loadMoreButton: 'Show More Posts',
            backToTopButton: 'Back to Top',
            emptyState: {
                title: 'No draft posts found',
                subtitle: 'There are no draft posts available for this filter',
            },
        },

        scheduled: {
            loadMoreButton: 'Show More Posts',
            backToTopButton: 'Back to Top',
            emptyState: {
                title: 'No scheduled posts found',
                subtitle: 'There are no scheduled posts available for this filter',
            },
        },
    },

    forumPickerPage: {
        loadMoreButton: 'Show More Stories',
        noTokensFound: 'No results found',
        searchPlaceholder: 'Search',
        sectionTitle: {
            ai: 'Artificial Intelligence',
            memeTokens: 'Meme Tokens',
            artAndMusic: 'Art & Music',
            debateAndVoting: 'Debate & Voting',
            crypto: 'Crypto',
            cars: 'Cars',
            games: 'Games',
            countries: 'Countries',
            teams: 'Teams',
            specialty: 'Specialty',
            fashion: 'Fashion',
            sport: 'Sport',
            'western-sports': 'Western Sports',
            nascar: 'NASCAR',
            'formula-1': 'Formula 1',
        },
    },
    myTokens: {
        title: 'My Channels',
    },

    tokenStats: {
        stats: {
            totalMembers: 'Members',
            totalPosts: 'Posts',
        },
    },
};
